<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs"/>
    </div>
    <div class="form-npa law-page">
      <div class="position">
        <div class="bg-white p-20">
          <div class="form-head">
            <Widget position="menu_profile"/>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  v-on="on"
                  class="navbar-toggler-profile"
                >
                  {{ $t("Профиль") }} <span class="caret"></span>
                </v-btn>
              </template>
              <v-list class="navbar-collapse">
                <v-list-item>
                  <Widget position="menu_profile"/>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="form-body">
            <div 
              class="links"
            >
              <!---
              <div v-if="isEnforecement">
                <router-link
                  :to="$i18nRoute({ name: 'create-law' })"
                  v-if="user && (user.roleCoordinator === true || user.roleAdmin === true)"
                  tag="button"
                  class="btn btn-default"
                >
                  {{ $t("Добавить закон") }}
                </router-link>
              </div>  
              -->

              <div 
                class="links_statistic"

              >
                <span @click="sendStatistic">{{ $t('Статистика по исполнению законов') }}</span>
                <a
                  class="upload_exel-file"
                  :href="baseUrl + `download/excel?type=law`"
                >
                  {{ $t('Скачать') }}
                  <img src="@/assets/icons/excel.png" />
                </a>
              </div>
            </div>  
            <div class="search-detaile">
              <LawSearch
                v-bind:data="data"
                v-bind:user="user"
                :view-name="viewName"
                @searchLaw="getDataSearch($event)"
                @resetLaw="resetDataSearch($event)"
                
              />
              <div 
                class="search-result"
              >
                <div class="search_totals"> 
                  <div
                    v-for="total in totals"
                    :key="total.key"
                  > 
                    <p 
                      class="search_totals-item"
                      v-show="total.isShow"
                    >
                      <span 
                        class="item_total-title"
                      >
                        {{ total.transName }}
                      </span>:

                      <span 
                        class="item_total"
                        :class="total.key"
                        @click="sendNorm(total.key)"
                      >
                        {{ total.value }}
                      </span>
                    </p>
                  </div>
                </div>  

                <div v-if="!isNormSearch">
                  <v-simple-table v-if="items.length">

                    <LawTable
                      v-bind:lawItems="items"
                      v-bind:user="user"
                      v-bind:inProgressStatus="data.inProgressStatus"
                      @order="sortData"
                      @filter="sortingFilterHandler"
                      @cancelSorting="cancelSorting()"
                    />
                  </v-simple-table>
                </div>  
                <div v-else>
               
                  <LawNormTable 
                    :norms="items"
                    :developers="searchData.refDeveloper"
                  />
                </div>

                <div class="private-footer">
                
                </div>
                <v-pagination
                  v-model="page"
                  :length="pagesCount"
                  :total-visible="7"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Widget from '@/components/app/Widget'
  import LawTable from '@/components/law/LawTable'
  import LawSearch from '@/components/law/LawSearch'
  import Law from '@/model/law'
  import {mapMutations, mapGetters} from 'vuex'
  import {Trans} from "@/plugins/Translation"
  import LawNormTable from '@/components/law/LawNormTable'

  export default {
    //Временно нужно удалить
    props: {
      viewName: {
        type: String,
        default: ''
      }
    },

    components: {
      Widget,
      LawTable,
      LawSearch,
      LawNormTable
    },
    data: () => ({
      isNormSearch: false,
      udalitPotom: [],
      breadcrumbs: [],
      tableFields: [],
      search: {},
      sortSettings: {},
      items: [],
      itemsTotal: 0,
      page: 1,
      pagesCount: 1,
      user: [],
      data: null,
      countNorms: null,
    }),
    watch: {
      $route: 'fetchData',
      page() {
        this.searchLaw()
      }
    },
    created() {
      this.fetchData()
      this.scrollToTop()
    },
    mounted() {
      if (!this.isEnforecement) {
        this.search.executionLawsChosen = true
        this.$forceUpdate()
      }

      this.fetchData()
    },

    computed: {
      ...mapGetters({
        searchData: 'getSearchData'
      }),
      //Убрать потом условие админа
      baseUrl () {
        return process.env.VUE_APP_BACK_URL
      },

      isEnforecement() {
        return this.viewName != 'viewName'
      },

      totals () {
        if (!this.countNorms) {
          return [
            {
              key: 'law',
              transName: this.$t('По запросу найдено законов'),
              value: this.itemsTotal,
              isShow: true,
            },
          ]
        }
  
        return [
          {
            key: 'law',
            transName: this.$t('По запросу найдено законов'),
            value: this.itemsTotal,
            isShow: true,
          },
          {
            key: 'all',
            transName: this.$t('В них норм по исполнению законов'),
            value:  this.countNorms.total,
            isShow: this.search.executionLawsChosen,
          },
          {
            key: 'executed',
            transName: this.$t('Из них исполнено'),
            value: this.countNorms.executed,
            isShow: this.search.executionLawsChosen
          },
          {
            key: 'notExecuted',
            transName:  this.$t('Из них не исполнено'),
            value: this.countNorms.notExecuted,
            isShow: this.search.executionLawsChosen,
          }
        ]
      }
    },

    methods: {
      ...mapMutations(['setLoading']),
      uploadExelFile () {
        Law.getExelFile()
      },
      sendNorm (key) {
        if (key == 'law') {
          this.search.norm = null
          this.isNormSearch = false;
        } else {
          this.search.norm = key
          this.isNormSearch = true;
        }

        this.$forceUpdate();
        this.fetchData()
      },
      fetchData() {
        this.setLoading(true)
        Law.getLawData()
          .then((response) => {
            this.data = response.data
            this.user = this.data.user
            this.breadcrumbs = [
              {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
              {text: this.$i18n.t('Исполнение законов'), disabled: true}
            ]
            this.searchLaw()
        
            this.setLoading(false)
          })
          .catch((error) => {
            this.$router.push(Trans.i18nRoute({
              name: 'error',
              params: {
                status: error.response.status
              }
            }))
            this.setLoading(false)
          })
      },
      getDataSearch(search) {
        this.search = {...this.search, ...search}
        this.page = 1
        this.searchLaw()
      },
      resetDataSearch() {
        this.search = {}
        this.page = 1
        this.searchLaw()
      },
      searchLaw() {
        this.setLoading(true)
        this.search.page = this.page
        Law.getList('profile', this.search)
          .then((response) => {
            this.countNorms = response.countNorms
            this.items = response.items
            const paginator = response.paginationData
            this.itemsTotal = paginator.totalCount
            this.pagesCount = paginator.pageCount
            this.setLoading(false)
          })
          .catch((error) => {
            this.$router.push(Trans.i18nRoute({
              name: 'error',
              params: {
                status: error.response.status
              }
            }))
            this.setLoading(false)
          })
      },
      sortData(sortKey) {
        this.page = 1
        this.search = {...this.search, ...{ page: this.page, orderBy: sortKey.key, orderDir: sortKey.value } }
        this.searchLaw()
      },

      sortingFilterHandler(filter) {
        
      },

      cancelSorting () {
        this.page = 1
        this.search = { page: this.page }
        this.searchLaw()
      },

      sendStatistic () {
        this.$router.push({
          name: 'law-statistic'
        })
      },
      
      scrollToTop() {
        window.scrollTo(0, 0)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .links {
    display: flex;
    align-items: center;

    &_statistic {
      text-decoration: underline;
      font-weight: 500;
      cursor: pointer;
    }
  }
  .item_total {
    font-size: 24px !important;
    font-weight: 600;
    margin-left: 10px;
    cursor: pointer;
    text-decoration: underline;

    &-title {
      font-size: 17px;
      font-weight: 600;
    }
  }

  .search_totals {
    display: flex;

    &-item {
      margin-right: 40px;
    }

    @media (max-width: 1000px) {
      flex-direction: column;
      justify-content: start;
    }
    .normTotal {
      color: #2196f3;
    }

    .notExecuted {
      color: #e45d5d;
    }
  }
  
  .upload_exel-file {
    margin-left: 20px;
    display: flex;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
      margin-left: 10px;
    }
  }

  .links_statistic {
    display: flex;
    align-items: center;
  }
</style>